export const LOAD_ACTION_TYPES = "[GQL] ACTION_TYPES";
